import { createRoot } from 'react-dom/client';
import { App } from './App';
import { hydrateSiteContent } from './lib/siteContent';
import './styles/globals.css';

/**
 * Paint first, then fill in.
 *
 * This used to wait for the CMS before mounting anything, which meant a blank
 * screen for as long as the feed took and left no moment in which to show that
 * something was loading. The app now mounts at once and the feed lands into it:
 * lists draw placeholders in the shape of what is coming, and swap to the real
 * thing when it arrives. `hydrate` bumps `siteContentVersion`, which re-renders
 * the tree.
 */
createRoot(document.getElementById('root')!).render(<App />);
void hydrateSiteContent();
